import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "app/popleads/modules/accounts/redux/accountsRedux";
import InputWithIcon from "app/popleads/components/ui-kit/Input";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import ChatGptDrawer from "app/popleads/components/Chat/ChatGptDrawer";

const OfficialAccountsActions = () => {
    const { user } = useSelector((state) => state.auth);
    const { searchInput } = useSelector((state) => state.accounts);

    const dispatch = useDispatch();

    const handleSearch = (value) => {
        dispatch(actions.search(value));
    };

    const handleClearInput = () => {
        handleSearch("");
    };

    return (
        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
            <InputWithIcon
                leftIcon="search"
                rightIcon={searchInput?.length > 0 ? "x" : null}
                minLength={1}
                debounceTime={300}
                onChange={(event) => handleSearch(event.target.value)}
                leftIconClick={handleClearInput}
                rightIconClick={handleClearInput}
                className="w-100 form-control"
                placeholder={"Search..."}
                id="kt_datatable_search_query"
                value={searchInput}
            />

            {user?.permissions?.ACCOUNT_OFFICIAL === 1 && (
                <div className="d-none d-sm-flex buttonDesktop">
                    <ButtonWithText
                        buttonStyle="inverted"
                        variant="success"
                        leftIcon="plus"
                        onClick={() => dispatch(actions.toggleAccountAddButton(true))}
                    >
                        Add New Account
                    </ButtonWithText>
                </div>
            )}

            <div
                style={{
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minWidth: "40px",
                    minHeight: "40px",
                }}
            >
                <ChatGptDrawer className={"m-0 btn-borderless"} />
            </div>
        </div>
    );
};

export default OfficialAccountsActions;
